import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

import {
  ASSESSMENT_TYPE,
  ATTACHMENT_CONTENT_TYPE,
} from "@/types/models/ContentAttachment.interface";

const { textXSObj } = typographyStyles;

const { ui } = constants.colors;
const core200 = ui.core[200];
const core500 = ui.core[500];
const core600 = ui.core[600];
const core700 = ui.core[700];
const neutral25 = ui.neutral[25];
const neutral100 = ui.neutral[100];
const neutral500 = ui.neutral[500];

const green300 = ui.green[300];
const pink500 = ui.pink[500];
const pink600 = ui.pink[600];
const purple500 = ui.purple[500];
const teal700 = ui.teal[700];
const yellow700 = ui.yellow[700];

export const containerCss = {
  position: "relative" as const,
};

const containerStyles = {
  padding: "12px 8px",
  marginBottom: "12px",
  flexDirection: "row-reverse" as const,
  justifyContent: "space-between",
  color: neutral500,
  borderRadius: "8px",
};

export const checkboxCss = (isSelected = false) => {
  return {
    ...containerStyles,
    ...(isSelected
      ? {
          border: `1px solid ${core600}`,
          svg: {
            rect: {
              stroke: core600,
            },
          },
        }
      : {
          border: `1px solid ${neutral100}`,
        }),
    "&:hover": {
      ...(isSelected
        ? {
            svg: {
              rect: {
                stroke: core600,
              },
            },
          }
        : {
            svg: {
              rect: {
                stroke: core200,
              },
            },
          }),
      color: neutral500,
      border: `1px solid ${core200}`,
    },
  };
};

export const viewableContainerCss = {
  ...containerStyles,
  border: `1px solid ${core600}`,
};

export const filledIconCss: CSSObject = {
  rect: {
    fill: core600,
    stroke: core600,
  },
};

export const hollowIconCss: CSSObject = {
  rect: {
    stroke: neutral100,
    strokeWidth: "2px",
  },
};

export const viewButtonCss: CSSObject = {
  position: "absolute" as const,
  borderRadius: "6px",
  color: core700,
  padding: "4px 8px",
  top: "13px",
  right: "55px",
};

export const labelCss: CSSObject = {
  display: "flex",
  gap: "8px",
};

const activityIconColor = (
  activityType: ASSESSMENT_TYPE | ATTACHMENT_CONTENT_TYPE,
) => {
  let styles = {};

  switch (activityType) {
    case "ANNOTATIONS":
      styles = { stroke: core500 };
      break;
    case "CHECKS_FOR_UNDERSTANDING_QUIZ":
      styles = { fill: yellow700 };
      break;
    case "GUIDED_HIGHLIGHTING_QUIZ":
      styles = { fill: purple500 };
      break;
    case "POLL":
      styles = { stroke: teal700 };
      break;
    case "POWER_WORDS_ACTIVITY":
      styles = {
        fill: green300,
        stroke: green300,
      };
      break;
    case "QUIZ":
      styles = { fill: core500 };
      break;
    case "WRITE_PROMPT":
      styles = { stroke: pink600 };
      break;
    case "GRAPHIC_ORGANIZERS":
      styles = { fill: pink500 };
      break;
  }
  return styles;
};

export const activityIconCss = (
  activityType: ASSESSMENT_TYPE | ATTACHMENT_CONTENT_TYPE,
) => {
  return {
    path: {
      ...activityIconColor(activityType),
    },
  };
};

export const betaTagCss: CSSObject = {
  ...textXSObj,
  position: "absolute",
  minWidth: "2rem",
  padding: "0 8px",
  borderRadius: "12px",
  fontWeight: 400,
  fontSize: "12px",
  color: neutral25,
  background: constants.colors.brand.blue[500],
  top: "18px",
  left: "195px",
};
